
import React from 'react';
import { LucideIcon } from "lucide-react";

interface AmenityItemProps {
  icon: LucideIcon;
  text: string;
}

const AmenityItem: React.FC<AmenityItemProps> = ({ icon: Icon, text }) => {
  return (
    <div className="flex items-center">
      <Icon className="h-4 w-4 mr-1.5 text-tribal-primary" />
      <span>{text}</span>
    </div>
  );
};

export default AmenityItem;
